// @ts-nocheck

import { reducerWrapper } from '../../support/utils';

import { GENERATE_3P_TEST_LINK } from '../../actions/EmailOnboarding/GenerateTestLink';

var INIT_STATE = {
  loading: false,
  error: null,
};

function Handler(state, action) {
  switch (action.type) {
    case GENERATE_3P_TEST_LINK.response:
      return Object.assign({}, state, {
        loading: false,
        error: null,
        ...action.data,
      });

    default:
      return state;
  }
}

const GenerateTestLink = reducerWrapper(INIT_STATE, Handler, {
  request: [GENERATE_3P_TEST_LINK],
  error: [GENERATE_3P_TEST_LINK],
  resetOn: ['APP_CHANGE'],
});

export default GenerateTestLink;
